import { Label } from "@king-ict/eupisi-ui/components";
import { hrDateWithTime } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ProgramRequestStatus } from "../../models/ProgramRequest/ProgramRequestStatus";
import { getProgramRequestStatusColor } from "../../utils/programRequestUtils";
import StaticField from "../StaticField";
import styles from "./ProgramRequestHeader.module.scss";

export interface ProgramRequestHeaderProps {
  programRequestId: number;
  programRequestDate: Date;
  programRequestStatusId: ProgramRequestStatus;
  programRequestStatusString: string;
}

export function ProgramRequestHeader(
  {
    programRequestId,
    programRequestDate,
    programRequestStatusId,
    programRequestStatusString
  }: ProgramRequestHeaderProps
) {
  const { t } = useTranslation();

  return (
    <Row className="mt-5">
      <Col md={4}>
        <StaticField
          label={t("request.requestId") + ":"}
          value={programRequestId.toString()}
        />
      </Col>
      <Col md={6}>
        <StaticField          
          label={t("common.programRequestCreateDate") + ":"}
          value={hrDateWithTime(programRequestDate)}
        />
      </Col>
      <Col md={2}>
        <div>
          <div className={`${styles.statusCaption} text-right pb-2`}>
            {t("common.status") + ":"}
          </div>
          <div className={"d-flex justify-content-end"}>
            <Label color={getProgramRequestStatusColor(programRequestStatusId)}>
              {programRequestStatusString}
            </Label>
          </div>
        </div>
      </Col>
    </Row>
  );
}